import React from 'react';
interface SectionProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  darker?: boolean;
}
export function Section({
  id,
  children,
  className = '',
  darker = false
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 px-4 md:px-8 ${darker ? 'bg-brand-dark' : 'bg-brand-surface'} ${className}`} data-id="element-196">
      <div className="max-w-7xl mx-auto" data-id="element-197">{children}</div>
    </section>;
}